import { useTranslation } from "react-i18next";
import { usePaymnetContext } from "../..";
import Loader from "../../Loader/Loader";
import { PaymentAmount, PaymentFor, PaymentVendor } from "./payment.card";

interface IStep {
    loading: boolean;
    setLoading: (loading: boolean) => void;
}

const Step1 = ({ loading, setLoading }: IStep) => {
    const { t } = useTranslation();
    const { state, update } = usePaymnetContext();

    if (loading) return <Loader />

    return <>
        <PaymentVendor />
        <PaymentFor />
        <PaymentAmount />
        <hr className="line" />
        <button
            className="payment-btn"
            onClick={() => update({ ...state, stepIndex: 1 })}
        >
            <span>{t("wizard1Submit")}</span>
            <img src="https://pg-vnext-banners.s3.eu-central-1.amazonaws.com/vnext-images/pgvnext-payment-images/arrow-right.svg" alt="arrow-right" className="icon" />
        </button>
    </>
};

export default Step1;